<template>
  <FetchTracker class="fetch-tracker">
    <template #headline><span></span></template>
    <template #default="{ item: request }">
      <slot :item="request">
        {{ request.type !== 'fetch' ? request.type.toUpperCase().slice(0, 3) : request.method }} {{
          request.url.pathname
        }}
        <span
            v-for="key in [ 'id', 'file_id', 'file_ids', ]"
            :key="key"
        >
          <span v-if="key === 'file_ids' && request.url.searchParams.get(key)">
            {{ key }}={{ request.url.searchParams.get(key) ?? '' }}
          </span>
          <span v-if="request.url.searchParams.get(key)">
            {{ key }}={{ request.url.searchParams.get(key) ?? '' }}
          </span>
        </span>
      </slot>
    </template>
  </FetchTracker>
</template>

<script setup lang="ts">
import FetchTracker from "@/libraries/vue-fetch/components/FetchTracker.vue";
</script>

<style scoped lang="scss">

</style>